class ProductMap {
  constructor(container) {
    this.container = container;
    this.setup();

    this.windowOnResizeHandler = () => {
      let isSmDevice = !st.Media.isMin("md");
      return this.gmap.setOptions({
        draggable: !isSmDevice
      });
    };
    this.windowOnResizeHandler();
    $(window).on("resize", this.windowOnResizeHandler);
  }

  setup() {
    let marker;
    let locationTitle =        this.container.getAttribute("data-location-title");
    let locationLat =         +this.container.getAttribute("data-location-lat");
    let locationLng =         +this.container.getAttribute("data-location-lng");
    let locationZoom =        +this.container.getAttribute("data-location-zoom");
    let locationAddress =      this.container.getAttribute("data-location-address");
    let locationDescription =  this.container.getAttribute("data-location-description");

    this.gmap = new google.maps.Map(this.container, {
      center: {lat: locationLat, lng: locationLng},
      zoom: locationZoom || 8,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      }
    }
    );

    // Wrap map controls in a wrapper div,
    // so they are offseted to the left/right margin of the actual map's viewport
    let wrapMapControls = () => {
      return $(this.container).find("div.gmnoprint").each(function(i, element) {
        if ($(element).closest(".gmap-controls-wrapper").length > 0) { return; }
        return $(element).wrap("<div class='gmap-controls-wrapper'><div class='gmap-controls-wrapper-inner'><div class='gmap-controls-wrapper-inner2'></div></div></div>");
      });
    };

    google.maps.event.addDomListener(this.gmap, 'tilesloaded', wrapMapControls);
    wrapMapControls();

    // Move the center of the map a little bit to the left,
    // so it's not covered by .product-map-sidebar
    let panMapBySidebarWidth = () => {
      if (st.Media.isMin("md")) {
        let productMapSidebarWidth = $(this.container).closest(".product-map").find(".product-map-sidebar").width();
        return this.gmap.panBy(productMapSidebarWidth / 2, 0);
      }
    };

    // $(window).resize(panMapBySidebarWidth)
    panMapBySidebarWidth();

    marker = new google.maps.Marker({
      position: {lat: locationLat, lng: locationLng},
      map: this.gmap,
      title: locationTitle
    });

    // infoWindowContent = """
    //   <h5>Adres</h5>
    //   <p>#{locationAddress.replace("\n", "<br />")}</p>
    // """
    // if locationDescription
    //   infoWindowContent += """
    //   <h5>Wskazówki dojazdu</h5>
    //   <p>#{locationDescription.replace("\n", "<br />")}</p>
    //   """

    // infoWindow = new google.maps.InfoWindow
    //   content: infoWindowContent

    // # Open info window when clicking on the marker
    // marker.addListener "click", ->
    //   infoWindow.open(gmap, marker)

    // # Open info window on start
    // infoWindow.open(gmap, marker)
  }


  destroy() {
    return $(window).off("resize", this.windowOnResizeHandler);
  }
}

onGoogleLoad(() => {
  $(".product-map-gmap").each(function() {
    return window.productMap = new ProductMap(this);
  })
})



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/product_map.js